/**
 * Procedure Categories and Procedures for MD in Laboratory Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 2, 8-12: "Operational and Investigation Skills")
 */
export const LABORATORY_MEDICINE_PROCEDURES = {
  "Specimen Collection, Hematology & Transfusion Procedures": [
    "Venipuncture, Finger-Prick & Blood Sample Collection",
    "Bone Marrow Aspiration, Touch Smear Preparation & Bone Biopsy",
    "Routine Hemogram (Hb, TLC, DLC, ESR, Hematocrit, Reticulocyte Count & Buffy Coat)",
    "Peripheral Blood Smear Preparation & Staining",
    "Sickle Cell, Osmotic Fragility & G6PD Deficiency Testing",
    "Coagulation Screening Tests (BT, CT, PT, APTT, TT, D-Dimer & Clot Retraction)",
    "Donor Phlebotomy & Blood Sample Processing",
    "Major ABO & Rh Blood Grouping & Cross-Matching (Coombs Test)",
    "Whole Blood Component Separation (PRBC, FFP, Platelets, Cryoprecipitate) & Apheresis",
  ],
  "Clinical Biochemistry & Body Fluid Analysis Procedures": [
    "Physical, Chemical & Microscopic Analysis of Urine, CSF, Pleural & Peritoneal Fluids",
    "Urine Pregnancy Testing",
    "Manual & Automated Estimation of Blood Glucose, Urea, Creatinine, Uric Acid & Proteins",
    "Serum Electrolytes & Blood Gas (ABG) Analysis",
    "Serum Lipid Profile Estimation",
    "Hormone Assays (TSH, T4, T3, Cortisol, Reproductive & Pituitary Hormones)",
    "Cardiac & Tumor Marker Assays (Troponin, CK-MB, CEA, CA125, AFP, BHCG)",
    "Protein & Hemoglobin Electrophoresis",
  ],
  "Microbiology, Immunology & Molecular Diagnostics Procedures": [
    "Microbiological Staining (Gram, AFB, Giemsa, Albert & India Ink)",
    "Culture Media Preparation, Specimen Inoculation & Culture",
    "Antibiotic Sensitivity Testing (AST) & Serological Tests (Widal, VDRL, ELISA)",
    "Rapid Diagnostic Testing & TORCH Screening",
    "Immunofluorescence Microscopy & Western Blotting",
    "DNA Extraction & Spectrophotometry",
    "Nucleic Acid Amplification Techniques (PCR & RT-PCR)",
    "Gel Electrophoresis Performance & Documentation",
    "Fine Needle Aspiration Cytology (FNAC) & Liquid-Based PAP Smear Preparation",
  ],
};

export const LABORATORY_MEDICINE_CATEGORIES = Object.keys(LABORATORY_MEDICINE_PROCEDURES);

export const isMDInLaboratoryMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("laboratory medicine") || d.includes("lab medicine") || d.includes("central lab");
};
